import React, { useState, useEffect } from 'react';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import {
  Box,
  Button,
  ButtonGroup,
  Paper,
  Tab,
  Tabs
} from '@material-ui/core';

const SalesTable = (props) => {
  
  const [currentTable, setCurrentTable] = useState([]);
  const [month, setMonth] = useState(true);
  const [tabValue, setTabValue] = useState(0);

  const columns = [
    { label: "Day", name: "day" },
    { label: "Month", name: "month" },
    { label: "Year", name: "year" },
    { label: "Total Sales", name: "sales" },
    { label: "Expenses", name: "expenses" },
    {
      label: "Profit",
      name: "profit",
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta) => (
          <font color={ value < 0 ? "red" : null }>{value}</font>
        )
      }
    }
  ];

  // Initially, The table will be set with the monthly data
  useEffect(() => {
    const result = [];
    let startDate = moment(props.dates.startDate);

    // The additional 'OR' condition is important to make sure the loop runs even if the months are the same.
    while (startDate.isBefore(props.dates.endDate) || startDate.isSame(props.dates.endDate, 'month')) {

      let totalMonthSales = 0;
      for ( let i = 0; i < props.salesOrders.length; i++ ) {
        let salesOrderTotal = 0;
        for ( let j = 0; j < props.salesOrders[i].payments.length; j++ ) {
          const currentPayment = props.salesOrders[i].payments[j];
          if(startDate.isSame(currentPayment.createdAt, 'month')) {
            salesOrderTotal += currentPayment.amount;
          }
        }
        totalMonthSales += salesOrderTotal;
      }

      let totalMonthExpenses = props.expenses.reduce((prevExpense, currentExpense) => {
        if(startDate.isSame(currentExpense.createdAt, 'month')) return prevExpense + currentExpense.total;
        else return prevExpense;
      }, 0);

      result.push({
        month: startDate.format("MMMM"),
        year: startDate.format("YYYY"),
        sales: totalMonthSales,
        expenses: totalMonthExpenses,
        profit: totalMonthSales - totalMonthExpenses
      });

      startDate.add(1, 'month');
    }
    
    setCurrentTable(result.reverse());

  }, [props.salesOrders, props.expenses, props.dates]);

  const options = {
    selectableRows: 'none',
    viewColumns: false
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Function to group Sales by Day
  const groupByDay = () => {
    const result = [];
    let startDate = moment(props.dates.startDate);

    while (startDate.isBefore(props.dates.endDate) || startDate.isSame(props.dates.endDate, 'day')) {

      let totalDaySales = 0;
      for ( let i = 0; i < props.salesOrders.length; i++ ) {
        let salesOrderTotal = 0;
        for ( let j = 0; j < props.salesOrders[i].payments.length; j++ ) {
          const currentPayment = props.salesOrders[i].payments[j];
          if(startDate.isSame(currentPayment.createdAt, 'day')) {
            salesOrderTotal += currentPayment.amount;
          }
        }
        totalDaySales += salesOrderTotal;
      }

      let totalDayExpenses = props.expenses.reduce((prevExpense, currentExpense) => {
        if(startDate.isSame(currentExpense.createdAt, 'day')) return prevExpense + currentExpense.total;
        else return prevExpense;
      }, 0);

      result.push({
        day: `${startDate.format("dddd")}, ${startDate.format("DD/MM")}`,
        year: startDate.format("YYYY"),
        sales: totalDaySales,
        expenses: totalDayExpenses,
        profit: totalDaySales - totalDayExpenses
      });

      startDate.add(1, 'day');
    }

    setCurrentTable(result.reverse());
    setMonth(false);
  };

  // Function to group Sales by Month
  const groupByMonth = () => {
    const result = [];
    let startDate = moment(props.dates.startDate);

    // The additional 'OR' condition is important to make sure the loop runs even if the months are the same.
    while (startDate.isBefore(props.dates.endDate) || startDate.isSame(props.dates.endDate, 'month')) {
      
      let totalMonthSales = 0;
      for ( let i = 0; i < props.salesOrders.length; i++ ) {
        let salesOrderTotal = 0;
        for ( let j = 0; j < props.salesOrders[i].payments.length; j++ ) {
          const currentPayment = props.salesOrders[i].payments[j];
          if(startDate.isSame(currentPayment.createdAt, 'month')) {
            salesOrderTotal += currentPayment.amount;
          }
        }
        totalMonthSales += salesOrderTotal;
      }

      let totalMonthExpenses = props.expenses.reduce((prevExpense, currentExpense) => {
        if(startDate.isSame(currentExpense.createdAt, 'month')) return prevExpense + currentExpense.total;
        else return prevExpense;
      }, 0);

      result.push({
        month: startDate.format("MMMM"),
        year: startDate.format("YYYY"),
        sales: totalMonthSales,
        expenses: totalMonthExpenses,
        profit: totalMonthSales - totalMonthExpenses
      });
      
      startDate.add(1, 'month');
    }

    setCurrentTable(result.reverse());
    setMonth(true);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <ButtonGroup variant="text" color="primary" aria-label="text primary button group">
          <Button
            onClick={groupByDay}
          >
            Daily
          </Button>
          <Button
            onClick={groupByMonth}
          >
            Monthly
          </Button>
        </ButtonGroup>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 2,
          mb: 1
        }}
      >
        <Paper>
          <Tabs
            value={tabValue}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleTabChange}
            centered
          >
            <Tab label="Sales"/>
            <Tab label="Expenses"/>
            <Tab label="Profits"/>
          </Tabs>
        </Paper>
      </Box>
      <Box>
        { tabValue === 0 ?
        <MUIDataTable
          title={"Sales"}
          data={currentTable}
          columns={ month ?
            columns.filter(column => !["day", "expenses", "profit"].includes(column.name))
            : columns.filter(column => !["month", "expenses", "profit"].includes(column.name))
          }
          options={options}
        />
        : null }
        { tabValue === 1 ?
        <MUIDataTable
          title={"Expenses"}
          data={currentTable}
          columns={ month ?
            columns.filter(column => !["day", "sales", "profit"].includes(column.name))
            : columns.filter(column => !["month", "sales", "profit"].includes(column.name))
          }
          options={options}
        />
        : null }
        { tabValue === 2 ?
        <MUIDataTable
          title={"Profits"}
          data={currentTable}
          columns={ month ? columns.filter(column => column.name !== "day") : columns.filter(column => column.name !== "month")}
          options={options}
        />
        : null }
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 2
        }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={props.hideSalesTable}
        >
          Return
        </Button>
      </Box>
    </Box>
  )
};

export default SalesTable;